export default __webpack_public_path__ + "static/1-b5c646195aa4cdabf1a64e788f3cba82.webp";